import { useEffect } from 'react';

import { useAnalytics } from '@inflearn/analytics';
import { isEmpty } from 'lodash-es';
import useClientAccountProfileQuery from '../../queries/useClientAccountProfileQuery';

export default function useSetUserToThirdParty() {
  const { analytics } = useAnalytics();
  const { data: profile } = useClientAccountProfileQuery();

  useEffect(() => {
    if (!profile) {
      return;
    }

    // GTM
    const isB2C = isEmpty(profile.group || profile.managedGroup || {});
    void analytics.track('gtm.customInit', {
      userId: profile.id,
      mxp___user: {
        user_id: profile.id,
        user_name: profile.name,
        user_email: profile.email,
        role_b2c: isB2C,
        role_b2b: !isB2C,
        role_admin: profile.isAdmin,
        role_instructor: profile.isInstructor,
      },
    });
  }, [profile]);
}
